import { RootState } from "../indexReducers";

export const badgeData = (state: RootState) =>
  state.publicBadgeReducer.badgeData;

export const loadBadgeDataStatus = (state: RootState) =>
  state.publicBadgeReducer.loadBadgeDataStatus;
